import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'app-side-menu-tab-group',
  standalone: true,
  imports: [ MatDividerModule ],
  templateUrl: './side-menu-tab-group.component.html',
  styleUrl: './side-menu-tab-group.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
// eslint-disable-next-line @tseslint/no-extraneous-class
export class SideMenuTabGroupComponent {}
